
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kiosks/[cName]/brands/[brandId]",
      function () {
        return require("private-next-pages/kiosks/[cName]/brands/[brandId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kiosks/[cName]/brands/[brandId]"])
      });
    }
  